import Swal from 'sweetalert2'
import apiMarim from '../../../services/service_undefined_v2'
import moment from 'moment'
import pen from '../../../assets/pen.png'
import search from '../../../assets/search.png'

export default {
  components: {
    pen,
    search
  },
  data () {
    return {
      transfer_data: [],
      transfer_search: [],
      hostshift: '',
      search: '',
      currentPage: 1,
      items_perpage: 10,
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      }
    }
  },
  created () {
    this.checkUser()
    if (sessionStorage.hostshift) {
      this.hostshift = JSON.parse(sessionStorage.hostshift)
    } else {
      this.$router.push('/')
    }
  },
  computed: {
    paginate: function () {
      // console.log(this.transfer_data)
      this.totalItem = this.transfer_data.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.transfer_data.slice(index, index + this.items_perpage)
    }
  },
  methods: {
    CheckSearch () {
      if (this.search === '') {
        this.transfer_data = this.transfer_search
      } else {
        this.transfer_data = this.transfer_search.filter(e => e.transfer_code.includes(this.search) || e.transfer_status.includes(this.search) || e.product.filter(p => { if (p.name != null) { if (p.name.includes(this.search)) return p } }).length > 0)
      }
      this.onChange(1)
    },
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    onChange (pageNumber) {
      this.currentPage = pageNumber
    },
    getTransferData () {
      // this.$store.commit('Loading')
      this.search = ''
      apiMarim.selectOutTransferStock({}, result => {
        this.transfer_data = []
        this.transfer_search = []
        if (result.data.status) {
          // eslint-disable-next-line padded-blocks
          result.data.data.forEach(val => {
            let status = val.transfer.transfer_status === 'Waiting' ? 'รออนุมัติ' :  val.transfer.transfer_status === 'PaddingWaiting' || val.transfer.transfer_status === 'PaddingConfirm'  ? 'ดำเนินการ' : val.transfer.transfer_status === 'Success' ? 'สำเร็จ' : 'ยกเลิก'

            this.transfer_data.push({
              transfer_id: val.transfer.id,
              transfer_code: val.transfer.transfer_code,
              transfer_date: moment(val.transfer.transfer_date).add(543, 'year').format('DD/MM/YYYY HH:mm:ss'),
              branch_out_name: val.transfer.branch_out_name,
              branch_in_name: val.transfer.branch_in_name,
              remark: val.transfer.remark,
              is_cancel_branch: val.transfer.is_cancel_branch,
              transfer_status: status,
              status: val.transfer.transfer_status,
              // isEdit: edit,
              product: val.transfer_product
            })
            this.transfer_search.push({
              transfer_id: val.transfer.id,
              transfer_code: val.transfer.transfer_code,
              transfer_date: moment(val.transfer.transfer_date).add(543, 'year').format('DD/MM/YYYY HH:mm:ss'),
              branch_out_name: val.transfer.branch_out_name,
              branch_in_name: val.transfer.branch_in_name,
              remark: val.transfer.remark,
              is_cancel_branch: val.transfer.is_cancel_branch,
              transfer_status: status,
              status: val.transfer.transfer_status,
              // isEdit: edit,
              product: val.transfer_product
            })
          })
        }
        // this.$store.commit('Loading')
      },
      errors => {
        // this.$store.commit('Loading')
        Swal.fire({
          icon: 'error',
          title: 'ดึงข้อมูลรายการโอนย้าย ไม่สำเร็จ',
          showConfirmButton: false,
          timer: 2000
        })
      })
    },
    openDetailTransfer (val) {
      this.$store.state.transfer_detail = val
      this.$store.state.isBranchTranfer = false
      $('#itemStockOutInfo').modal('show')
    }
  },
  mounted () {
    $('#ToolModalTransferOut').on(
      'show.bs.modal',
      function () {
        this.getTransferData()
      }.bind(this)
    )
    $('#itemStockOutInfo').on(
      'show.bs.modal',
      function () {
        // console.log(this.$store.state.transfer_detail)
        // eslint-disable-next-line no-extra-bind
      }.bind(this)
    )
    $('#itemStockOutInfo').on(
      'hide.bs.modal',
      function () {
        // console.log('hide')
        // this.search = ''
        this.getTransferData()
        // console.log(this.$store.state.transfer_detail)
        // eslint-disable-next-line no-extra-bind
      }.bind(this)
    )
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/pos/stock_out_list.js